import React from "react";
import styled from "styled-components";

function Layout({ children }) {
     return <LayoutContainer>{children}</LayoutContainer>;
     // layout 안에 있는 아이들이 다 칠드런
}

export default Layout;

const LayoutContainer = styled.div`
     max-width: 1200px;
     min-width: 800px;
     height: 100%;
     margin: 0 auto;
     border: 5px solid #888;
`;
